import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserSessionService } from '../../app-user-session.service';
import { DoneWaitServiceService } from '../../outpatient/portal-scheduling-management/done-wait-service-popup/done-wait-service.service';
import { PatientParms } from '../../shared';
import { PatientVM } from '../patients';

@Component({
  selector: 'app-similar-patients-data',
  templateUrl: './similar-patients-data.component.html',
  styleUrls: ['./similar-patients-data.component.css']
})
export class SimilarPatientsDataComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  patientCode: number;
  findSimilarBy: any = [];
  similarData: any = [];
  patientParms: PatientParms = {};
  patServices: any = [];
  showServiceDataFlag: number = 0;
  serviceType: number;
  constructor(
    private _userSessionService: UserSessionService,
    private _doneWaitServiceService: DoneWaitServiceService,
    public translate: TranslateService,
    private _route: ActivatedRoute
  ) {
    this.serviceType = +this._route.snapshot.params['mode'];
  }
  ngOnInit() {
    this.similarData = [];
    this.similarData = this._userSessionService.getSessionKey('findSimilarBy');
    if (this.similarData.length > 0) {
      this.showServiceDataFlag = 0;
    }
    this._userSessionService
      .subscribeToKey$('findSimilarBy').pipe(
        takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys && keys.name == 'findSimilarBy') {
          if (keys.value && keys.value) {
            this.similarData = keys.value
            if (this.similarData.length > 0) {
              this.showServiceDataFlag = 0;
            }
          }
        }
      });
  }
  ///subscribe to data
  similarPatRowIconClick(pat: PatientVM) {
    if (pat.code) {
      this.getPatServices(pat.code);
    }

  }



  getPatServices(patientCode: number) {
    this.patientParms.patCode = patientCode;
    this.patientParms.serviceType = this.serviceType;
    if (this.patientParms.patCode) {
      this._doneWaitServiceService.getDoneWaitService(this.patientParms)
        .pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
          if (res.data && res.data.length > 0) {
            this.patServices = res.data;
            this.showServiceDataFlag = 1;
          }
        })
    }

  }
  // simple order request new reservation for pat
  newReservation(row) {
    if (row) {
      this._userSessionService.setSessionKey("NewReservationFromPatListOrPatHistory", row);
      this._userSessionService.closeModalKey('SimilarPatientsDataComponent', { findSimilarBy: {} });
    }
  }

  // simple order request new patient

  getpatientdataRow(patient) {
    this._userSessionService.setSessionKey('SimilarPatData', patient);
    this._userSessionService.closeModalKey('SimilarPatientsDataComponent', { findSimilarBy: {} });
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();

  }
}
